import {
  InvoiceHeader,
  ConfirmationFormSection,
  BillingInfoSectionSlot as BillingInfoSection
} from "../../common/components";
import { ClientSlot as ClientSection } from "./ClientSlot";
import { ok } from "../../../../utils/common";

export { ClientSection, BillingInfoSection, InvoiceHeader as InvoiceHeaderSlot };
export { ConfirmationFormSection };

export { default as TicketSection } from "./PeruTicket";
export const submitInvoiceAndPrepareFiscalTicket = async () => ok(true);
